import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { Box } from 'grommet/components/Box';
import { Anchor } from 'grommet/components/Anchor';
import { Text } from 'grommet/components/Text';
import { Menu } from 'grommet/components/Menu';
/*import { Image } from 'grommet/components/Image';;
import image from '../Assets/user.svg';*/
/*import { WelcomeCtrl } from '../Controllers/Account/WelcomeCtrl';*/
import { Paragraph } from 'grommet/components/Paragraph';
import { NAVBAR } from '../Constants';

class Navbar extends Component {
    constructor(props) {
        super(props);
        var token = sessionStorage.getItem('token')
        if (token === null) {
            this.props.history.push({
                pathname: '/login'
            })
        }
        this.state = {
            data: '',
            ebox: sessionStorage.getItem('ebox') === 'SI' ? true : false
        }
    }

    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    componentDidMount() {
        var dataSess = JSON.parse(sessionStorage.getItem('dataWelcome')) !== undefined ? JSON.parse(sessionStorage.getItem('dataWelcome')) : '';
        //var eboxSess = sessionStorage.getItem('ebox') !== undefined ? sessionStorage.getItem('ebox') : '';
        this.setState({
            data: dataSess,
            //ebox: eboxSess
        });
    }

    render() {
        const userType = sessionStorage.getItem("userType")

        return (
            <Box direction='row' justify='center' align='center'>

                {/* <Box align='center' className='image' >
                    <Image src={image} className='user' style={{ marginTop: '80px' }} />
                </Box> */}

                <Box direction='column' style={{ width: '100%' }}>
                    <Box direction='column' align='start' className='contentlogin'>
                        {this.state.data !== undefined && this.state.data !== null && this.state.data !== '' ?
                            <Box className='benvenuto'>
                                <h3 className='titlebenvenuto'>
                                    {`Benvenuto ${this.state.data.name}`}
                                </h3>
                                <Text className='subtitlebenvenuto'><h4>
                                    {`${this.state.data.address} ${this.state.data.number}, ${this.state.data.zip} ${this.state.data.city} ${this.state.data.district}`}</h4>
                                </Text>
                            </Box> : ''}
                    </Box>

                    <div className='menuDesktop'>
                        <Box align='start' className='menupadding'>
                            <Box direction='row' className='benvenuto'>
                                <Anchor className='navbar' href='/Home' onClick={() => sessionStorage.setItem("tab", "0")}>
                                    Home
                                </Anchor>
                                <Anchor className='navbar' href='/EstrattoConto'>
                                    Estratto conto
                                </Anchor>
                                <Anchor className='navbar' href={this.state.ebox === true ? '/DisputeOnlineRegistered' : '/DisputeOnline'}>
                                    Dispute online
                                </Anchor>
                                <Anchor className='navbar' href='/Insoluti'>
                                    Insoluti
                                </Anchor>

                                {userType === 'PortaleAmex' ?
                                    <Anchor className='navbar' style={{ marginRight: '0' }} href='/Setting'>
                                        Impostazioni
                                 </Anchor>
                                    : null}
                            </Box>
                        </Box>
                    </div>

                    <div className='burgerMenu'>

                        <Box align='start' className='menupadding'>

                            <Menu className='benvenuto' style={{ width: '68%', backgroundColor: 'rgb(249, 249, 249)', borderLeft: '40px white', borderRight: '40px white' }}
                                label='Menu'
                                dropAlign={{ left: 'left', top: 'bottom' }}
                                icon={<i className='icon-menu' aria-hidden="true"></i>}
                                items= {userType === 'PortaleAmex' ?  [
                                    { label: 'Home', href: '/Home' },
                                    { label: 'Estratto conto', href: '/EstrattoConto' },
                                    { label: 'Dispute online', href: this.state.ebox === true ? '/DisputeOnlineRegistered' : '/DisputeOnline' },
                                    { label: 'Insoluti', href: '/Insoluti' },
                                    { label: 'Impostazioni', href: '/Setting' }
                                ] : [
                                    { label: 'Home', href: '/Home' },
                                    { label: 'Estratto conto', href: '/EstrattoConto' },
                                    { label: 'Dispute online', href: this.state.ebox === true ? '/DisputeOnlineRegistered' : '/DisputeOnline' },
                                    { label: 'Insoluti', href: '/Insoluti' }
                                ]}
                            />

                        </Box>
                    </div>

                    {this.state.data && this.state.data !== undefined && this.state.data.passwordExpireDay && this.state.data.passwordExpireDay !== undefined ?
                        <div className='pwdExp'>
                            <Box align='start' className='menupadding'>
                                {this.state.data.passwordExpireDay < 11 ?
                                    <Box className="menupadding ">
                                        <Paragraph className="pwdParagraph">
                                            {NAVBAR.exp_pwd_1}{this.state.data.passwordExpireDay}{this.state.data.passwordExpireDay === 1 ?
                                                `${NAVBAR.exp_pwd_3}` : `${NAVBAR.exp_pwd_2}`}
                                            {NAVBAR.exp_pwd_4} <a href='/Setting/ModificaPassword'>qui.</a>
                                        </Paragraph>
                                    </Box>
                                    : ''}
                            </Box>
                        </div>
                        : ''}

                </Box>

            </Box>
        );
    }
}

export default Navbar = withRouter(Navbar);
